import React from 'react';

const SkeletonCard = ({ index }) => (
  <div
    className="p-1 w-full md:w-1/2 lg:w-1/3 opacity-0 animate-fade-in"
    style={{ animationDelay: `${index * 50}ms` }}
  >
    <div className="relative bg-white p-4 rounded-[5px] h-64 shadow-md overflow-hidden">
      {/* Status tag skeleton */}
      <div className="h-6 w-24 bg-gray-200 rounded animate-pulse" />
      
      {/* Date skeleton */}
      <div className="mt-3 h-5 w-40 bg-gray-200 rounded animate-pulse" />
      
      {/* Stats skeleton */}
      <div className="flex justify-between py-2 mt-4">
        <div>
          <div className="h-3 w-16 bg-gray-200 rounded animate-pulse mb-2" />
          <div className="h-8 w-12 bg-gray-200 rounded animate-pulse" />
        </div>
        <div>
          <div className="h-3 w-24 bg-gray-200 rounded animate-pulse mb-2" />
          <div className="h-8 w-16 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    </div>
  </div>
);

// Skeleton months data - mimics the actual month structure
const skeletonMonths = [
  { weeksCount: 5 },
  { weeksCount: 4 },
  { weeksCount: 5 },
];

const TimesheetLoading = () => {
  let cardIndex = 0;
  
  return (
    <div>
      {skeletonMonths.map((month, monthIndex) => (
        <div key={monthIndex}>
          {/* Month header skeleton */}
          <div className="text-2xl font-medium mb-2">
            <div className="h-8 w-40 bg-gray-200 rounded animate-pulse" />
          </div>
          
          {/* Card grid skeleton */}
          <div className="flex flex-wrap mb-4">
            {[...Array(month.weeksCount)].map((_, weekIndex) => {
              const currentCardIndex = cardIndex++;
              return <SkeletonCard key={weekIndex} index={currentCardIndex} />;
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TimesheetLoading;
